export const US_POST_JOIN_DOCUMENTS = [
  { id: "SOCIAL_SECURITY_CARD", label: "Social Security Card (SSN) Copy", required: true },
  { id: "EMPLOYMENT_ELIGIBILITY_VERIFICATION", label: "Employment Eligibility Verification Form (I-9)", required: true },
  { id: "TAX_WITHHOLDING_FORM", label: "Tax Withholding Form (W-4 / P45)", required: true },
  { id: "DIRECT_DEPOSIT_AUTHORIZATION", label: "Direct Deposit Authorization Form", required: false },
] as const;

export type UsPostJoinDocumentType = (typeof US_POST_JOIN_DOCUMENTS)[number]["id"];
export type UsPostJoinDocumentFiles = Partial<Record<UsPostJoinDocumentType, File | null>>;

